// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Symbol from "../Data.Symbol/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Record_Unsafe from "../Record.Unsafe/index.js";
import * as Unsafe_Coerce from "../Unsafe.Coerce/index.js";
var Tag = function (x) {
    return x;
};
var unsafeToVariantRep = Unsafe_Coerce.unsafeCoerce;
var unsafeFromVariantRep = Unsafe_Coerce.unsafeCoerce;
var toString = function (v) {
    return v;
};
var tag = function (v) {
    var v1 = unsafeToVariantRep(v);
    return v1.type;
};
var showTag = Data_Show.showString;
var sameLabelsNil = {};
var sameLabelsCons = function () {
    return {};
};
var sameLabels = function () {
    return function () {
        return function () {
            return function () {
                return {
                    convert: function (v) {
                        return v;
                    }
                };
            };
        };
    };
};
var ordTag = Data_Ord.ordString;
var mkTag = function (dictIsSymbol) {
    var reflectSymbol = Data_Symbol.reflectSymbol(dictIsSymbol);
    return function () {
        return function (p) {
            return reflectSymbol(p);
        };
    };
};
var match = function () {
    return function () {
        return function () {
            return function (elim) {
                return function (v) {
                    return Record_Unsafe.unsafeGet(v)(elim);
                };
            };
        };
    };
};
var eqTag = Data_Eq.eqString;
var encodeTag = Foreign_Generic_Class.stringEncode;
var elimTagNil = {};
var elimTagCons = function () {
    return {};
};
var convert = function (dict) {
    return dict.convert;
};
var constructVariantNil = {};
var constructVariantCons = function () {
    return {};
};
var construct = function (dictFunctor) {
    var map = Data_Functor.map(dictFunctor);
    return function () {
        return function () {
            return function () {
                return function (elim) {
                    return function (v) {
                        var payload = Record_Unsafe.unsafeGet(v)(elim);
                        return map(function (value) {
                            return unsafeFromVariantRep({
                                type: v,
                                value: value
                            });
                        })(payload);
                    };
                };
            };
        };
    };
};
export {
    mkTag,
    toString,
    tag,
    construct,
    match,
    convert,
    eqTag,
    showTag,
    ordTag,
    encodeTag,
    elimTagNil,
    elimTagCons,
    constructVariantNil,
    constructVariantCons,
    sameLabelsNil,
    sameLabelsCons,
    sameLabels
};
